/**
 * TRAC-468: Session sync storage utilities.
 *
 * Extracted from useSessionSync.ts so non-React modules (RealChatAgentService)
 * can clear session sync data without importing a React hook module.
 */

import { logger } from './logger';

const STORAGE_KEY_SESSION_HASH = 'traci_session_hash';
const STORAGE_KEY_SESSION_USER_ID = 'traci_session_user_id';

/**
 * Clear session sync data from localStorage (hash + user ID).
 */
export function clearSessionSyncData(): void {
  try {
    localStorage.removeItem(STORAGE_KEY_SESSION_USER_ID);
    localStorage.removeItem(STORAGE_KEY_SESSION_HASH);
  } catch (e) {
    logger.warn('[SESSION_SYNC] Failed to clear session data:', e);
  }
}
